<div class="d-grid" *ngIf="memberInfo$ | async as memberInfo">
  <!--Banner-->
  <ng-container *ifScreenSize="screenSize.Desktop">
    <ng-container *inPopulation="populations.Default">
      <div class="banner" role="banner">
        <h1>{{ 'home.page.title' | translate }} {{ memberInfo.firstName }}</h1>
      </div>
    </ng-container>
    <ng-container *inPopulation="populations.Kids">
      <div
        class="container"
        [ngClass]="{
          'all-star-banner': memberInfo.kidType == KidType.AllStars,
          'junior-banner': memberInfo.kidType == KidType.Junior,
          'd-none': memberInfo.kidType == KidType.Other
        }"
      ></div>
    </ng-container>

    <ng-container *inPopulation="populations.Club1901">
      <div class="container">
        <div class="club1901-banner"></div>
      </div>
    </ng-container>
  </ng-container>

  <!--Mobile Barcode-->
  <ng-container *ifScreenSize="screenSize.Mobile">
    <fgb-barcode [isHomePage]="true"></fgb-barcode>
  </ng-container>
</div>

<!--Scorecard carousel-->
<div class="">
  <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>
</div>

<div class="container mt-4">
  <!--Vouchers-->
  <fgb-vouchers></fgb-vouchers>
</div>

<div
  class="container d-flex flex-column"
  [ngClass]="{
    'flex-column-reverse': isKid
  }"
>
  <!-- Featured Rewards -->
  <fgbcl-featured-rewards [showAllPath]="'/rewards/raffles'"></fgbcl-featured-rewards>

  <!-- Announcements -->
  <fgbcl-announcements></fgbcl-announcements>

  <!-- Widgets -->
  <div class="widget-container">
    <div class="home-widgets pt-4">
      <ng-container *inPopulation="populations.Default">
        <!-- <ng-container *hasTag="tags.Member; checkValue: false">
          <div (click)="launchShop(shopURL)">
            <img class="widget shop-widget cursor-pointer" src="assets/images/widgets/shop-widget.jpg" />
          </div>
        </ng-container> -->

        <!-- <ng-container *hasTag="tags.STH; checkValue: false"> -->
        <div [routerLink]="['/games/arcade']">
          <img class="widget shop-widget cursor-pointer" src="assets/images/widgets/arcade.jpg" />
        </div>
        <!-- </ng-container> -->

        <a [routerLink]="'/tv'">
          <img class="widget tv-widget" src="assets/images/widgets/temp-tv-widget.jpg" />
        </a>

        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
          <ng-container *ifScreenSize="screenSize.Mobile">
            <a [routerLink]="'/offers'">
              <img class="widget w-100 h-100" src="assets/images/widgets/offers-widget.jpg" />
            </a>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *inPopulation="populations.Kids">
        <ng-container *ngIf="memberInfo$ | async as memberInfo">
          <ng-container *ngIf="memberInfo.kidType == 'All-Stars'">
            <a [routerLink]="'/games/arcade'">
              <img class="widget" src="assets/images/widgets/all-star-arcade.jpg" />
            </a>

            <a [routerLink]="'/tv'">
              <img class="widget" src="assets/images/widgets/all-star-latest.jpg" />
            </a>
          </ng-container>
          <ng-container *ngIf="memberInfo.kidType == 'Junior'">
            <a [routerLink]="'/games/arcade'">
              <img class="widget" src="assets/images/widgets/jr_tile-arcade.jpg" />
            </a>

            <a [routerLink]="'/tv'">
              <img class="widget" src="assets/images/widgets/jr-latest.jpg" />
            </a>
          </ng-container>
          <ng-container *ngIf="memberInfo.kidType == 'Other'">
            <a [routerLink]="'/training-zone'">
              <img class="widget" src="assets/images/widgets/training-widget.jpg" />
            </a>

            <a [routerLink]="'/tv'">
              <img class="widget" src="assets/images/widgets/tv-widget.jpg" />
            </a>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
      <ng-container *inPopulation="populations.Default">
        <ng-container *ifScreenSize="screenSize.Desktop">
          <a [routerLink]="'/offers'">
            <img class="offers-widget w-100 h-100 mt-4" src="assets/images/widgets/offers-widget.jpg" />
          </a>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *inPopulation="populations.Club1901">
      <a [routerLink]="'/tv'">
        <img class="offers-widget w-100 h-100 mt-4" src="assets/images/1901/1901-latest.jpg" />
      </a>

      <a [routerLink]="'/offers'">
        <img class="offers-widget w-100 h-100 mt-4" src="assets/images/1901/1901-offers.jpg" />
      </a>
    </ng-container>
  </div>
</div>
